import { render, staticRenderFns } from "./ShelvesList.vue?vue&type=template&id=1ee07174&scoped=true&"
import script from "./ShelvesList.vue?vue&type=script&lang=js&"
export * from "./ShelvesList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1ee07174",
  null
  
)

export default component.exports